import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { BackOfficeNumbersWrap, BackOfficeNumbers } from './DashboardStyled';
import { IconTitle } from './common';
import { DashboardInformation } from './Dashboard.types';
import { PROJECT_NAME } from '../../helpers/helperFunctions';

interface NumberOfMembersProps {
  count: number;
  backOffice: DashboardInformation | null;
}

export const NumberOfMembers = ({
  backOffice,
  count
}: NumberOfMembersProps) => {
  const { t } = useTranslation('dashboard');
  const joinedOn = moment(backOffice?.user?.dateCreated)
    .format('DDMMYYYY')
    .split('');

  const joinedAfter = String(count).padStart(8, '0').split('');

  return (
    <BackOfficeNumbersWrap>
      <div>
        <IconTitle title={`You Joined ${PROJECT_NAME} on`} />
        <div>
          {joinedOn.map((num, index) => {
            return <BackOfficeNumbers key={index}>{num}</BackOfficeNumbers>;
          })}
        </div>
      </div>
      <div>
        <IconTitle title={t('number_of_members.rigth_title')} />
        <div>
          {joinedAfter.map((num, index) => {
            return (
              <BackOfficeNumbers orange key={index}>
                {num}
              </BackOfficeNumbers>
            );
          })}
        </div>
      </div>
    </BackOfficeNumbersWrap>
  );
};
